"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalInitRequest = void 0;
var WithdrawalInitRequest = /** @class */ (function () {
    function WithdrawalInitRequest() {
    }
    return WithdrawalInitRequest;
}());
exports.WithdrawalInitRequest = WithdrawalInitRequest;
;
//# sourceMappingURL=withdrawalInit.request.js.map